import { useEffect, useState } from "react";
import { T } from "@/components/T";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { fetchPanchangContent } from "@/lib/api";
import { GlossaryProvider, GlossaryTerm } from "@/components/GlossaryTerm";
import { ArrowLeft, BookOpen } from "lucide-react";

export default function PanchangHowItWorks() {
  const [c, setC] = useState({ explainer_intro: "", explainer: [] });
  useEffect(() => { fetchPanchangContent().then(setC).catch(() => {}); }, []);

  return (
    <GlossaryProvider source="panchang">
      <Helmet>
        <title>How Dharmartha calculates your Panchangam · Dharmartha</title>
        <meta name="description" content="How Dharmartha computes the five limbs, samvats, muhurtas and horas from the real positions of the Sun and Moon, using the Lahiri Ayanamsha and Swiss Ephemeris." />
      </Helmet>
      <div className="mx-auto max-w-3xl px-5 py-12 md:px-8" data-testid="panchang-how-it-works">
        <Link to="/panchang" className="inline-flex items-center gap-1.5 text-sm text-ink-3 transition-colors hover:text-saffron"><ArrowLeft className="h-4 w-4" /> <T>Back to Panchangam</T></Link>
        <h1 className="mt-4 flex items-center gap-2 font-serif-latin text-3xl text-ink sm:text-4xl"><BookOpen className="h-7 w-7 text-saffron" /> <T>How Dharmartha calculates your Panchangam</T></h1>
        {c.explainer_intro && <p className="mt-3 text-base leading-relaxed text-ink-2">{c.explainer_intro}</p>}

        <div className="mt-10 space-y-10">
          {(c.explainer || []).map((s, i) => (
            <section key={i} data-testid={`explainer-section-${i}`}>
              <h2 className="font-serif-latin text-2xl text-ink">{s.heading}</h2>
              {s.body && <p className="mt-2 text-base leading-relaxed text-ink-2 deva-lh">{s.body}</p>}
              {s.items?.length > 0 && (
                <ul className="mt-4 space-y-3">
                  {s.items.map((it, j) => (
                    <li key={j} className="border-l-2 border-[var(--gold-muted)] pl-4">
                      <span className="font-serif-latin text-ink"><GlossaryTerm>{it.title}</GlossaryTerm></span>
                      <span className="text-ink-2"> — {it.text}</span>
                    </li>
                  ))}
                </ul>
              )}
              {s.note && <p className="mt-3 text-sm italic text-ink-3">{s.note}</p>}
            </section>
          ))}
        </div>

        <div className="mt-12 border-t border-line pt-8">
          <Link to="/panchang" className="inline-flex items-center gap-2 border border-[var(--ink)] px-6 py-3 text-sm font-medium text-ink transition-colors hover:bg-ink hover:text-[var(--surface)]">
            <T>View today's Panchangam</T>
          </Link>
        </div>
      </div>
    </GlossaryProvider>
  );
}
